/**
 * Customer statuses types
 *
 * @type {object}
 */
export const statusesTypes = {
  active: 'active',
  blocked: 'blocked',
  deleted: 'deleted'
};
/**
 * Customer statuses
 *
 * @type {object}
 */

export const statuses = {
  [statusesTypes.active]: 'Активен',
  [statusesTypes.blocked]: 'Заблокирован',
  [statusesTypes.deleted]: 'Удален'
};
/**
 * Customer roles types
 *
 * @type {object}
 */

export const rolesTypes = {
  admin: 'admin',
  anonymous: 'anonymous',
  author: 'author',
  cashbox: 'cashbox',
  stock: 'stock',
  user: 'user',
  external_api: 'external_api',
  guest: 'guest',
  moderator: 'moderator',
  seller: 'seller',
  super_admin: 'super_admin'
};
/**
 * Customer roles
 *
 * @type {object}
 */

export const roles = {
  [rolesTypes.admin]: 'Администратор',
  [rolesTypes.anonymous]: 'Анонимный пользователь',
  [rolesTypes.author]: 'Автор статей',
  [rolesTypes.cashbox]: 'Касса (API)',
  [rolesTypes.stock]: 'Склад (API)',
  [rolesTypes.user]: 'Пользователь',
  [rolesTypes.external_api]: 'Внешнее API',
  [rolesTypes.guest]: 'Гость',
  [rolesTypes.moderator]: 'Модератор',
  [rolesTypes.seller]: 'Продавец',
  [rolesTypes.super_admin]: 'Супер Администратор'
};
/**
 * Customer gender types
 *
 * @type {object}
 */

export const genderTypes = {
  male: 'male',
  female: 'female'
};
/**
 * Customer gender
 *
 * @type {object}
 */

export const gender = {
  [genderTypes.male]: 'Мужской',
  [genderTypes.female]: 'Женский'
};
/**
 * Customer push notifications target types
 *
 * @type {Object}
 */

export const pushTargetTypes = {
  topic: 'topic',
  // group:  'group',
  device: 'device'
};
/**
 * Customer push notifications target titles
 *
 * @type {Object}
 */

export const pushTargetTitles = {
  [pushTargetTypes.topic]: 'На тему',
  // [pushTargetTypes.group]:  'Группе пользователей',
  [pushTargetTypes.device]: 'Пользователю'
};
/**
 * Customer push notifications topics types
 *
 * @type {Object}
 */

export const pushTopicsTypes = {
  all: '~ALL',
  androidAll: '~android~ALL',
  browserAll: '~browser~ALL',
  iosAll: '~ios~ALL'
};
/**
 * Customer push notifications topics titles
 *
 * @type {Object}
 */

export const pushTopicsTitles = {
  [pushTopicsTypes.all]: 'Все устройства',
  [pushTopicsTypes.androidAll]: 'Все Android устройства',
  [pushTopicsTypes.browserAll]: 'Все браузеры',
  [pushTopicsTypes.iosAll]: 'Все IOS устройства'
};
/**
 * Customer push notifications types
 *
 * @type {Object}
 */

export const pushNotificationTypes = {
  default: 'customer.defaultNotification',
  newCutomer: 'customer.newNotification'
};
/**
 * Customer push notifications titles
 *
 * @type {Object}
 */

export const pushNotificationTitles = {
  [pushNotificationTypes.default]: 'По умолчанию',
  [pushNotificationTypes.newCutomer]: 'Новое уведомление'
};